/**
 * Dynamically build a default message with the required contextual Vuelidate data.
 *
 * @param  {String} label The human-friendly field label.
 * @param  {Object} meta  The Vuelidate param meta data.
 *
 * @return {Object}
 */
const getMessage = (label, meta) => ({
    required: `The ${label} field is required.`,
    email: 'Must be a valid email address.',
    minLength: `The ${label} must be longer than ${(meta || {}).min || 0} characters.`,
});

export default {
    /**
     * Non-cached methods that are used by the Vue instance and template.
     *
     * @type Object ES6 methods
     */
    methods: {
        /**
         * Will get error messages for defined Vuelidate errors.
         *
         * @param {String} type    The Vuelidate or custom error type.
         * @param {Object} options Customization options.
         *
         * @return {Array}
         */
        TextFieldValidation_getErrorMessages (type, options = {}) {
            // Determine if the field has a Vuelidate error
            if (! this.$v[type].$error) {
                return [];
            }

            // Define method constants
            const errors = [];
            const label = options.label || type;
            const messages = options.messages || {};
            const rules = Object.keys(this.$v[type].$params);

            // Iterate through each Vuelidate rule
            rules.forEach(rule => {
                // Determine if the Vuelidate rule is invalid
                if (! this.$v[type][rule]) {
                    // Attempt to get any custom or overriding error message, otherwise fall back to default error messages
                    const message = messages[rule] || getMessage(label, this.$v[type].$params[rule])[rule];

                    // If an error message exists then push it to the errors return array
                    if (message) {
                        errors.push(message);
                    }
                }
            });

            // Return the errors messages array
            return errors;
        },
    },
};
